// GridFilter Component

import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classnames from 'classnames'

import IconButton from '../../common/icon_button/icon_button.jsx'
import SvgIcon from '../../common/svgicon/svgicon.jsx'
import Input from '../../common/input/input.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import PlannerSearchHistory from '../../planner/planner_searchhistory/planner_searchhistory.jsx'

class GridFilter extends Component {
  static get propTypes () {
    return {
      keyword: PropTypes.string,
      filters: PropTypes.array,
      histories: PropTypes.array,
      onSearchObjects: PropTypes.func,
      onChange: PropTypes.func,
      onSaveHistory: PropTypes.func,
      onClearHistory: PropTypes.func,
      onSelectHistory: PropTypes.func,
      filterTypes: PropTypes.array,
      onToggleExpand: PropTypes.func,
      isExpand: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      keyword: '',
      filters: [],
      histories: [],
      onSearchObjects: null,
      onChange: null,
      onSaveHistory: null,
      onClearHistory: null,
      onSelectHistory: null,
      filterTypes: [],
      onToggleExpand: null,
      isExpand: false
    }
  }

  constructor (props) {
    super(props)

    this.state = {
      dataDate: new Date()
    }

    this.data = {
      keyword: '',
      focusedIndex: -1,
      showFilterType: false,
      showFilterOption: false,
      showHistory: false,
      selectedFilterType: null,
      isFilterChanged: false,
      filters: this._getDisplayFilters(props.filters || [], props.filterTypes),
      filterTypes: props.filterTypes,
      filterOptions: []
    }

    this._references = {
      content: React.createRef(),
      filterInput: React.createRef(),
      dropDownType: React.createRef(),
      dropDownOption: React.createRef(),
      filter: React.createRef()
    }
  }

  componentDidUpdate () {
    this._updateDropdownPosition()
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    let bUpdateState = false

    if (
      nextProps.filters &&
      !_.isEqual(nextProps.filters, this.props.filters)
    ) {
      bUpdateState = true
      this.data.filters = this._getDisplayFilters(
        nextProps.filters || [],
        this.data.filterTypes
      )
    }

    if (nextProps.keyword !== this.props.keyword) {
      bUpdateState = true
      this.data.keyword = nextProps.keyword
    }

    if (bUpdateState) {
      this.setState({ dataDate: new Date() })
    }
  }

  render () {
    const {
      filters,
      keyword,
      selectedFilterType,
      showHistory,
      showFilterType,
      showFilterOption
    } = this.data
    const { histories, onClearHistory, onToggleExpand, isExpand } = this.props
    const bFocus = showFilterType || showFilterOption || showHistory

    return (
      <div className={`cgrid-filter${showHistory ? ' showhistory' : ''}`}>
        <div className='filtercont' ref={this._references.content}>
          <div className='filteraction'>
            <IconButton
              icon={isExpand ? 'arrow-up' : 'arrow-down'}
              iconSize='12'
              className='actionexpand'
              canHover
              onClick={onToggleExpand}
            />
          </div>
          <div
            className={classnames('filtermain', {
              hasfocus: bFocus
            })}
          >
            <div
              className={classnames('filtercol colfilterrecent', {
                hasfocus: bFocus
              })}
              onClick={this._onToggleHistory.bind(this)}
            >
              <IconButton icon='reset' canHover />
              <IconButton icon='arrow-down' canHover />
            </div>
            <div
              className='filtercol colfiltertags'
              ref={this._references.filter}
            >
              <div className='filtertags'>
                {filters.map((filter, idx) => (
                  <div
                    className='fitlertag'
                    key={`${filter.ident}-${filter.value}`}
                  >
                    <div className='tagcol coltype'>{filter.typeLabel}</div>
                    <div className='tagcol coltext'>{filter.text}</div>
                    {!filter.hideDelete && (
                      <div className='tagcol colaction'>
                        <IconButton
                          icon='x'
                          size='small'
                          type='alert'
                          onClick={this._onDeleteFilter.bind(this, idx)}
                        />
                      </div>
                    )}
                  </div>
                ))}
                <div className='fitlertag fitlertaginput'>
                  {selectedFilterType && (
                    <span className='filtertype'>
                      {selectedFilterType.labelIdent}
                    </span>
                  )}
                  <Input
                    name='keyword'
                    type='text'
                    maxLength={128}
                    styleType='filterinput'
                    label='common.newfilter.searchPlaceHolder'
                    value={keyword}
                    ref={this._references.filterInput}
                    onChange={this._onChangeSearchInput.bind(this)}
                    onFocus={this._onFocusSearchInput.bind(this)}
                    onBlur={this._onBlurSearchInput.bind(this)}
                    onKeyDown={this._onKeyDownSearchInput.bind(this)}
                  />
                </div>
              </div>
            </div>
            <div className='filtercol colfilterclose'>
              <IconButton
                icon='x'
                type='error'
                onClick={this._onClearAll.bind(this)}
              />
            </div>
          </div>
          {this._renderPopoverType()}
          {this._renderPopoverOption()}
          {showHistory && (
            <PlannerSearchHistory
              histories={histories}
              onClose={this._onCloseHistory.bind(this)}
              onClearHistory={onClearHistory}
              onSelectHistory={this._onSelectHistory.bind(this)}
            />
          )}
        </div>
      </div>
    )
  }

  /* Event handlers */
  _onChangeSearchInput (value) {
    const {
      selectedFilterType,
      showFilterType,
      filters,
      filterTypes
    } = this.data

    this.data.keyword = value
    this.data.focusedIndex = showFilterType ? -1 : 0
    this.setState({ dataDate: new Date() })

    let newSelectedType = selectedFilterType
    if (!newSelectedType && value) {
      newSelectedType = _.find(filterTypes, obj =>
        obj.labelIdent.replace(/\*/g, '').match(new RegExp(`^${value}$`, 'i'))
      )
      value = ''
    }

    if (newSelectedType) {
      // Search objects based on keyword
      this._searchAndShowFilterOptions(newSelectedType, value, filters)
    }
  }

  _onFocusSearchInput (ev) {
    ev.preventDefault()

    this._clearBlurTimeout()

    const { selectedFilterType, keyword, filters } = this.data

    if (selectedFilterType) {
      // Search objects based on keyword
      this._searchAndShowFilterOptions(selectedFilterType, keyword, filters)
    } else {
      this.data.showFilterType = true
      this.data.showHistory = false
    }

    this.setState({ dataDate: new Date() })
  }

  _onBlurSearchInput (ev) {
    ev.preventDefault()
    this.data.showFilterType = false
    this.data.showFilterOption = false

    this._timeBlurInput = window.setTimeout(() => {
      if (this.props.onSaveHistory && this.data.isFilterChanged) {
        this.data.isFilterChanged = false
        this.props.onSaveHistory(ev)
      }

      this.setState({ dataDate: new Date() })
    }, 500)
  }

  _clearBlurTimeout () {
    if (this._timeBlurInput) {
      window.clearTimeout(this._timeBlurInput)
    }
  }

  _onKeyDownSearchInput (ev) {
    const keyCode = ev.keyCode
    const {
      keyword,
      filterTypes,
      filters,
      showFilterOption,
      showFilterType,
      selectedFilterType,
      filterOptions
    } = this.data
    let focusedIndex = this.data.focusedIndex

    // If enter is pressed, start search by keyword and selected filters
    if (keyCode === 13) {
      if (focusedIndex !== -1) {
        if (showFilterType) {
          const searchFilterTypes = this._getFilteredTypes(
            filterTypes,
            keyword,
            showFilterType
          )
          this._onSelectFilterType(searchFilterTypes[focusedIndex], ev)
        } else if (showFilterOption) {
          this._onSelectFilterOption(filterOptions[focusedIndex], ev)
        }
      } else {
        this.data.showFilterType = false
        this.data.showFilterOption = false
        this.setState({ dataDate: new Date() })

        this._onChange()

        if (this.props.onSaveHistory) {
          this.props.onSaveHistory(ev)
        }
      }
      // If backspace is pressed, open the last added filter
    } else if (keyCode === 8 && !keyword) {
      ev.preventDefault()
      ev.stopPropagation()

      if (showFilterOption && selectedFilterType) {
        this.data.keyword = selectedFilterType.labelIdent.replace(/\*|:/g, '')
        this.data.focusedIndex = 1
        this.data.showFilterType = true
        this.data.showFilterOption = false
        this.data.selectedFilterType = null
        this.data.filterOptions = []

        this.setState({ dataDate: new Date() })
      } else {
        const lastFilter = filters[filters.length - 1]
        if (lastFilter && !lastFilter.hideDelete) {
          filters.pop()

          const filterType = _.find(
            filterTypes,
            obj => obj.ident === lastFilter.ident
          )
          this.data.focusedIndex = 0
          this._searchAndShowFilterOptions(filterType, lastFilter.text, filters)
        }
      }
    } else if (keyCode === 40 || keyCode === 38) {
      ev.preventDefault()
      ev.stopPropagation()

      let options = []
      if (showFilterType) {
        options = this._getFilteredTypes(filterTypes, keyword, showFilterType)
      } else if (showFilterOption) {
        options = [...filterOptions]
      } else {
        if (keyCode === 40) {
          this.data.showFilterType = true
        }
      }

      const incr = keyCode === 40 ? 1 : -1
      focusedIndex = this._getNextFocus(options, focusedIndex, incr)

      this.data.focusedIndex = focusedIndex
      this.setState({ dataDate: new Date() })
    }
  }

  _getNextFocus (options, focusedIndex, incr) {
    const totalOptions = options.length
    let idx = 0

    while (idx < totalOptions) {
      focusedIndex += incr

      if (focusedIndex < 0) {
        focusedIndex = totalOptions - 1
      } else if (focusedIndex === totalOptions) {
        focusedIndex = 0
      }

      if (options[focusedIndex]) {
        return focusedIndex
      }

      idx++
    }

    return -1
  }

  _onSelectFilterType (item, ev) {
    ev.preventDefault()

    if (item) {
      this.data.focusedIndex = -1

      if (item.ident === 'keyword') {
        this.data.showFilterType = false
        this.data.showFilterOption = false
        this.setState({ dataDate: new Date() })

        this._onChange()
      } else if (item.ident !== 'duedate') {
        this.data.keyword = ''
        this._searchAndShowFilterOptions(
          item,
          this.data.keyword,
          this.data.filters
        )
      }
    }
  }

  _searchAndShowFilterOptions (filterType, keyword, filters) {
    this.data.keyword = keyword
    this.data.selectedFilterType = filterType
    this.data.showFilterType = false
    this.data.showFilterOption = true

    this.setState({ dataDate: new Date() })

    if (this._references.filterInput.current) {
      this._references.filterInput.current.focus()
    }

    // Search objects based on selected type
    this._onSearchObjects(filterType, this.data.keyword, filters)
  }

  _onSelectFilterOption (item, ev) {
    ev.preventDefault()

    if (item) {
      const { selectedFilterType, filters } = this.data
      const existingItem = _.find(
        filters,
        obj => obj.value === item.value && obj.ident === item.ident
      )

      if (!existingItem && selectedFilterType) {
        this.data.filters.push({
          ident: selectedFilterType.ident,
          typeLabel: selectedFilterType.labelIdent,
          value: item.value,
          text: item.label
        })

        this._onChange()
      }
    }

    if (this._references.filterInput.current) {
      this._references.filterInput.current.focus()
    }

    this.data.selectedFilterType = null
    this.data.showFilterType = true
    this.data.showFilterOption = false
    this.data.keyword = ''
    this.data.filterOptions = []
    this.data.focusedIndex = -1

    this.setState({ dataDate: new Date() })
  }

  _onToggleHistory () {
    this.data.showHistory = !this.data.showHistory
    this.setState({ dataDate: new Date() })
  }

  _onCloseHistory () {
    this.data.showHistory = false
    this.setState({ dataDate: new Date() })
  }

  _onSelectHistory (history) {
    this.data.showHistory = false
    this.setState({ dataDate: new Date() })

    if (this.props.onSelectHistory) {
      this.props.onSelectHistory(history)
    }
  }

  _onDeleteFilter (filterIdx) {
    _.remove(this.data.filters, (obj, idx) => idx === filterIdx)
    this.setState({ dataDate: new Date() })

    this._onChange()
  }

  _onClearAll () {
    this.data.selectedFilterType = null
    this.data.showFilterType = false
    this.data.showFilterOption = false
    this.data.keyword = ''
    this.data.filterOptions = []

    _.remove(this.data.filters, obj => !obj.hideDelete)

    this.setState({ dataDate: new Date() })

    this._onChange()
  }

  /* Private functions */
  _getFilteredTypes (filterTypes, keyword, showFilterType) {
    const items = []

    filterTypes.forEach(item => {
      const pattern = new RegExp(
        keyword.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&').replace(/\$/g, '$$$$'),
        'gi'
      )

      if (
        !item.isHidden &&
        (!keyword ||
          (showFilterType &&
            (item.ident === 'keyword' || item.labelIdent.match(pattern))))
      ) {
        items.push({ ...item })
      }
    })

    return items
  }

  _renderPopoverType () {
    const { keyword, filterTypes, showFilterType, focusedIndex } = this.data
    const items =
      this._getFilteredTypes(filterTypes, keyword, showFilterType) || []

    return (
      <div
        className={`dropdown-list${showFilterType ? ' active' : ''}`}
        ref={this._references.dropDownType}
      >
        {items.map((item, idx) => (
          <div
            className={classnames('item hasicon', {
              focused: focusedIndex === idx
            })}
            key={item.ident}
            onClick={this._onSelectFilterType.bind(this, item)}
          >
            <div className='colicon'>
              <SvgIcon name={item.icon} size='16' className='iconcont' />
            </div>
            <div className='coltext'>
              <span className='text label'>{item.labelIdent}</span>
              {item.labelValue && (
                <span className='text'>{item.labelValue}</span>
              )}
            </div>
          </div>
        ))}
      </div>
    )
  }

  _renderPopoverOption () {
    const { filterOptions: items, showFilterOption, focusedIndex } = this.data

    return (
      <div
        className={`dropdown-list${showFilterOption ? ' active' : ''}`}
        ref={this._references.dropDownOption}
      >
        {items.length <= 0 && (
          <div className='message'>
            <IntlMessage ident='common.newfilter.messageNoOptionsFound' />
          </div>
        )}
        {items.map((item, idx) => (
          <div
            className={classnames('item', {
              hasimage: item.showImage,
              focused: focusedIndex === idx
            })}
            key={`${item.value}-${idx}`}
            onClick={this._onSelectFilterOption.bind(this, item)}
          >
            {item.showImage && (
              <div className='colimage'>
                <div className='imagecont'>
                  {item.imageUrl && <img src={item.imageUrl} alt='' />}
                </div>
              </div>
            )}
            <div className='coltext'>
              <span className='text label'>{item.label}</span>
            </div>
          </div>
        ))}
      </div>
    )
  }

  _getDisplayFilters (filters, filterTypes) {
    const labelIdentMap = {}
    filterTypes.forEach(filterType => {
      labelIdentMap[filterType.ident] = filterType.labelIdent
    })

    const newFilters = filters
    newFilters.forEach(filter => {
      filter.typeLabel = labelIdentMap[filter.ident] || ''
    })

    return newFilters
  }

  _onChange () {
    this.data.isFilterChanged = true

    if (this.props.onChange) {
      this.props.onChange(this.data.keyword, this.data.filters)
    }
  }

  _onSearchObjects (selectedFilterType, keyword, filters) {
    if (selectedFilterType && this.props.onSearchObjects) {
      const excludeIds = []

      filters.forEach(filter => {
        if (filter.ident === selectedFilterType.ident && filter.value) {
          excludeIds.push(filter.value)
        }
      })

      this.props.onSearchObjects(
        selectedFilterType.ident,
        keyword,
        excludeIds,
        options => {
          this.data.filterOptions = options || []

          this.setState({ dataDate: new Date() })
        }
      )
    }
  }

  _updateDropdownPosition () {
    if (
      this._references.filterInput.current &&
      this._references.content.current
    ) {
      const { x: leftInput } = ReactDOM.findDOMNode(
        this._references.filterInput.current
      ).getBoundingClientRect()
      const { x: leftContent, width: widthContent } = ReactDOM.findDOMNode(
        this._references.content.current
      ).getBoundingClientRect()

      const left = leftInput - leftContent
      let posLeft = `${left}px`
      let posRight = 'auto'

      if (left > widthContent - leftContent) {
        posLeft = 'auto'
        posRight = '46px'
      }

      if (this._references.dropDownType.current) {
        this._references.dropDownType.current.style.left = posLeft
        this._references.dropDownType.current.style.right = posRight
      }

      if (this._references.dropDownOption.current) {
        this._references.dropDownOption.current.style.left = posLeft
        this._references.dropDownOption.current.style.right = posRight
      }
    }

    if (this._references.filter.current) {
      const { width: widthFilter } = ReactDOM.findDOMNode(
        this._references.filter.current
      ).getBoundingClientRect()
      this._references.filter.current.scrollLeft = widthFilter
    }
  }
}

export default GridFilter
